export const creativeDomainData = [
  {
    name: 'Photography',
    image: require('../assets/images/photography.jpeg'),
    description:
      'In the realm of photography, the focus is on capturing and preserving special moments. The UiPath community emphasizes an intuitive approach, streamlining photo editing and organization processes to enhance the seamless preservation of cherished memories.',
    buttonlink: '',
  },
  {
    name: 'Content Writing',
    image: require('../assets/images/contentwriting.jpg'),
    description:
      'In the niche of specialized content creation, the primary objective is to craft compelling narratives. This community centers on intuitive approaches, ensuring streamlined processes for creating engaging content that captivates audiences and communicates ideas effectively.',
    buttonlink: '',
  },
  {
    name: 'Social Media Handling',
    image: require('../assets/images/socialmedia.jpeg'),
    description:
      'In the arena of social media management, the focus is on curating engaging content. This community emphasizes user-friendly strategies, streamlining processes for efficient scheduling, posting, and interaction to enhance online presence and audience engagement.',
    buttonlink: '',
  },
  {
    name: 'Event Management',
    image: require('../assets/images/eventmanagement.avif'),
    description:
      'In the domain of event management, the spotlight is on orchestrating memorable experiences. This community prioritizes user-friendly tools, streamlining processes for efficient planning, coordination, and execution to ensure seamless and successful events.',
    buttonlink: '',
  },
  {
    name: 'Video Editing',
    image: require('../assets/images/videoedit.jpg'),
    description:
      'Within the video editing sphere, the community centers around crafting compelling visual stories. Emphasizing user-friendly interfaces, it streamlines processes for efficient editing, enhancing the creation of engaging videos with seamless transitions and impactful storytelling.',
    buttonlink: '',
  },
  {
    name: 'Graphic Designing',
    image: require('../assets/images/graphicdesign.png'),
    description:
      'In the graphic design realm, the focus is on crafting visually captivating creations. This community prioritizes intuitive tools, streamlining processes for efficient design, enabling the creation of stunning graphics that effectively communicate ideas and captivate audiences.',
    buttonlink: '',
  },
]
